import i18n from '../i18n'

export default (name, args) => {
  const appTitle = i18n.t('appTitle')
  const pageTitle = i18n.te(`pageMetaTitle.${name}`) ? i18n.t(`pageMetaTitle.${name}`, args) : false

  document.title = [pageTitle, appTitle].filter(Boolean).join(' - ')
}
